import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC, ReactNode } from 'react'
import styled from 'styled-components'

import { Colours } from '@/utils/styles'

interface Props {
  icon: IconProp
  title: string
  detail: ReactNode
  warning?: boolean
}

const OuterContainer = styled.div<{ $warning?: boolean }>`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-gap: 10px;
  border: 1px solid;
  border-radius: 5px;
  border-color: ${props => (props.$warning ? Colours.orange : Colours.lightGray)};
  background: ${props => (props.$warning ? Colours.lightOrange : 'inherit')};
  padding: 7px;
`

const InnerContainer = styled.div`
  display: grid;
  grid-gap: 5px;
`

const DetailPill: FC<Props> = ({ icon, title, detail, warning }) => (
  <OuterContainer $warning={warning}>
    <div>
      <FontAwesomeIcon
        size="1x"
        icon={warning ? faWarning : icon}
        color={warning ? Colours.orange : undefined}
      />
    </div>
    <InnerContainer>
      <div>
        <strong>{title}</strong>
      </div>
      <div>{detail}</div>
    </InnerContainer>
  </OuterContainer>
)

export default DetailPill
